export const wizardConstants = {
  WIZARD_UPDATE_STEP: 'WIZARD_UPDATE_STEP',
};
